import { render, staticRenderFns } from "./SingleSearchResult.vue?vue&type=template&id=a21f5dd0&scoped=true&"
import script from "./SingleSearchResult.vue?vue&type=script&lang=js&"
export * from "./SingleSearchResult.vue?vue&type=script&lang=js&"
import style0 from "./SingleSearchResult.vue?vue&type=style&index=0&id=a21f5dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21f5dd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
